import {AnswerModel} from './AnswerModel.js';
import {AnswerOption} from './AnswerOption.js';
import {AnswerPoll} from './AnswerPoll.js';
import {AnswerQuestion} from './AnswerQuestion.js';
import {Audience} from './Audience.js';
import {ChatConnect} from './ChatConnect.js';
import {Eventify} from './Eventify.js';
import {PollAdminControl} from './PollAdminControl.js';
import {PollEdit} from './PollEdit.js';
import {PollFolderItem} from './PollFolderItem.js';
import {PollFolderList} from './PollFolderList.js';
import {PollFolderModel} from './PollFolderModel.js';
import {PollModel} from './PollModel.js';
import {PollResultsUpdate} from './PollResultsUpdate.js';
import {PollResultsUpdateContainer} from './PollResultsUpdateContainer.js';
import {PollRobotLogin} from './PollRobotLogin.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {AskResultViewer} from './ResultAskModel.js';
import {VeedoDrop} from './VeedoDrop.js';
import {VeejayAdmin} from './VeejayAdmin.js';
import {VeejayAdminChannel} from './VeejayAdminChannel.js';
import {VeejayAudience} from './VeejayAudience.js';
import {VeejayResources} from './VeejayResources.js';
import {getPrefix} from '../common/getPrefix.js';

export class Public {
	constructor(script) {
		if (!Public.Inited) {
			Public.Inited=true;
			console.log(`pollrobot Public.js: constructor w `, script); 
			if (!Public.Prefix) {			
				const res = getPrefix(script, `/poll/js/all.js`);
				Public.Prefix = res.Prefix;
				Public.Origin = res.Origin;
			}
			Audience.init();
			// ChatConnect.init();  // unsure what this was meant to be - currently an outline of something...?
			VeejayAudience.init(document);
		}
	}
}

if (document.readyState=='loading') {
	console.log(`pollrobot Public.js: creating Public class on DOMContentLoaded`);
	(function(cs) {
		document.addEventListener(`DOMContentLoaded`, function() {
			new Public(cs);
		});
	})(document.currentScript);
} else {
	console.log(`pollrobot Public.js: Creating Public class immediately`);
	new Public(document.currentScript);
}


